import React from 'react';
import { Subclass } from '../../../types/class-data';
import { ContentText } from '../../Common/ContentText';

interface SubclassFeaturesProps {
  subclass: Subclass;
  characterLevel: number;
  characterTier: number;
  subclassCardTier: 'foundation' | 'specialization' | 'mastery';
}

const SubclassFeatures: React.FC<SubclassFeaturesProps> = ({
  subclass,
  characterLevel,
  characterTier,
  subclassCardTier
}) => {
  // Determine which features are available based on actual character progression
  const hasFoundation = true; // Always available (required at character creation)
  const hasSpecialization = subclassCardTier === 'specialization' || subclassCardTier === 'mastery';
  const hasMastery = subclassCardTier === 'mastery';

  return (
    <>
      {/* Subclass Header */}
      <div className="class-feature subclass-header">
        <h4 className="class-feature__title">{subclass.name.toUpperCase()} SUBCLASS</h4>
        <div className="class-feature__description">
          <ContentText content={subclass.description} />
          {subclass.spellcastTrait && (
            <p><strong>Spellcast Trait:</strong> {subclass.spellcastTrait}</p>
          )}
        </div>
      </div>

      {/* Foundation Features */}
      {Array.isArray(subclass.foundationFeature) && subclass.foundationFeature.map((feature, index) => (
        <div key={`foundation-${index}`} className={`class-feature ${!hasFoundation ? 'feature-locked' : ''}`}>
          <h4 className="class-feature__title">
            {feature.name.toUpperCase()}
            <span className="feature-level">(Foundation)</span>
            {hasFoundation ? ' ✓' : ' 🔒'}
          </h4>
          <div className="class-feature__description">
            <ContentText content={feature.description} />
          </div>
        </div>
      ))}

      {/* Specialization Features */}
      {Array.isArray(subclass.specializationFeature) && subclass.specializationFeature.map((feature, index) => (
        <div key={`specialization-${index}`} className={`class-feature ${!hasSpecialization ? 'feature-locked' : ''}`}>
          <h4 className="class-feature__title">
            {feature.name.toUpperCase()}
            <span className="feature-level">(Specialization)</span>
            {hasSpecialization ? ' ✓' : ' 🔒'}
          </h4>
          <div className="class-feature__description">
            <ContentText content={feature.description} />
          </div>
        </div>
      ))}

      {/* Mastery Features */}
      {Array.isArray(subclass.masteryFeature) && subclass.masteryFeature.map((feature, index) => (
        <div key={`mastery-${index}`} className={`class-feature ${!hasMastery ? 'feature-locked' : ''}`}>
          <h4 className="class-feature__title">
            {feature.name.toUpperCase()}
            <span className="feature-level">(Mastery)</span>
            {hasMastery ? ' ✓' : ' 🔒'}
          </h4>
          <div className="class-feature__description">
            <ContentText content={feature.description} />
          </div>
        </div>
      ))}
    </>
  );
};

export default SubclassFeatures;